import React from "react";
import { Button, Paper, Typography } from "@mui/material";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

interface Props {
  href: string;
}

const Container = styled(Paper)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: theme.spacing(4),
  maxWidth: "360px",
}));

export const OnlyForProBlock = ({ href }: Props) => {
  const { t } = useTranslation();
  return (
    <Container data-testid="upgrade-to-pro">
      <Typography mb={2}>{t("fundamentals.onlyForProBlock.title")}</Typography>
      <Button variant="primary" href={href} endIcon={<ArrowForwardIosIcon />}>
        {t("fundamentals.onlyForProBlock.updateToPro")}
      </Button>
    </Container>
  );
};
